import styles from './SavedSearchesIntroStep.module.scss';

interface SavedSearchesIntroStepProps {
	body: React.ReactNode;
	icon: React.ReactNode;
	title: React.ReactNode;
}

const SavedSearchesIntroStep: React.FC<SavedSearchesIntroStepProps> = ({ body, icon, title }) => (
	<li className={styles.stepItem}>
		<div>{icon}</div>
		<div className={styles.text}>
			<span className={styles.stepTitle}>{title}</span>
			<p className={styles.stepBody}>{body}</p>
		</div>
	</li>
);

export default SavedSearchesIntroStep;
